export default __webpack_public_path__ + "static/media/hadeel.fc12ca2b.jpg";